export const TermsOfUsePdf = "/TermosDeUso.pdf";